import InputFiscalAmount, {
  type InputFiscalAmountProps,
} from './InputFiscalAmount';

export type { InputFiscalAmountProps };
export default InputFiscalAmount;
